var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGsfChat = function SvgGsfChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gsf-chat_svg__a",
    width: 21,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h20v20H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gsf-chat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.743 15.917q-.102.16-.34.182a.52.52 0 0 1-.427-.168l-1.669-1.668h-8.14a1.42 1.42 0 0 1-1.042-.433 1.42 1.42 0 0 1-.433-1.041v-.513h9.07a1.45 1.45 0 0 0 1.064-.443 1.45 1.45 0 0 0 .443-1.064V5h.513q.608 0 1.041.433t.433 1.042v8.916a.5.5 0 0 1-.154.378.5.5 0 0 1-.359.148m-13.75-5.378 1.18-1.18h7.923a.25.25 0 0 0 .184-.072.25.25 0 0 0 .072-.184V3.59a.25.25 0 0 0-.072-.184.25.25 0 0 0-.184-.073H4.25a.25.25 0 0 0-.185.073.25.25 0 0 0-.072.184zm-.5 1.964a.75.75 0 0 1-.52-.211.72.72 0 0 1-.23-.558V3.59q0-.621.443-1.064a1.45 1.45 0 0 1 1.064-.442h8.846q.621 0 1.064.442.442.443.442 1.064v5.513q0 .621-.442 1.064a1.45 1.45 0 0 1-1.064.442H5.692l-1.668 1.668a.735.735 0 0 1-.53.226"
  }))));
};
export default SvgGsfChat;